import { t } from '@lingui/macro';
import { TNotificationSubscription } from 'lendingApi/notifications';

export const SUBSCRIPTIONS = () => [
  { value: 'offered', label: t`Review offer(s)` },
  { value: 'action_required', label: t`Documents required` },
];

export const getSubscriptionsUpdateData = (
  currentSubscriptions: TNotificationSubscription[],
  selectedValues: string[],
): TNotificationSubscription[] => {
  return currentSubscriptions.map(({ status }) => ({
    status,
    subscribed: selectedValues.includes(status),
  }));
};
